import { useEffect } from "react";
import { jwtDecode } from 'jwt-decode';
import { connect } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { setTestUser } from "../components/user/actions";

import Assessment from "../components/Assessment/component/assessment";
import AssessmentReport from "../components/Assessment/component/Report/AssessmentReport";
import AssessmentSkillTest from "../components/Assessment/component/AssessmentSkillTest";
import WelcomeTestInstruction from "../components/Assessment/component/AssessmentSkillTest/WelcomeTestInstruction";

import CertificateDetailPage from "../components/QuizStudio/component/pages/CertificatePage/CertificateDetailPage";
import CertificatePage from "../components/QuizStudio/component/pages/CertificatePage";

import ChoosePathDetailsPage from "../components/QuizStudio/component/pages/Preparation/PlacementPrep/ChoosePathDetailsPage";
import ExamPrep from "../components/QuizStudio/component/pages/Preparation/ExamPrep";
import PlacementPrep from "../components/QuizStudio/component/pages/Preparation/PlacementPrep";

import QuizzesLibrary from "../components/QuizStudio/component/pages/QuizzesLibrary";

import QuizStudioLandingPage from "../components/QuizStudio/component/pages/QuizStudioLandingPage";

import TournamentsDetailPage from "../components/QuizStudio/component/pages/TournamentsPage/TournamentsDetailPage";
import TournamentRegisterPage from "../components/QuizStudio/component/pages/TournamentsPage/TournamentRegisterPage";
import TournamentsPage from "../components/QuizStudio/component/pages/TournamentsPage";

import CreateQuizSettings from "../components/QuizTestDashbaord/settings";
import ReportReview from "../components/QuizTestDashbaord/ReportReview/ReportReview";

import QuizTestPage from "../components/QuizStudio/component/pages/QuizTest/QuizTestPage";
import QuizTestReport from "../components/QuizStudio/component/pages/QuizTest/QuizTestReport";

import Dashbaord from "../components/QuizStudio/component/pages/Dashbaord";
import QuizPlayboard from "../components/QuizStudio/component/pages/QuizTest/Playboard";
import QuizTestsList from "../components/QuizStudio/component/pages/QuizTestsList";

import Confirmation from "../components/user/component/Confirmation";
import ForgotPassword from "../components/user/component/forgot_password";
import Login from "../components/user/component/login";
import NotFound from "../components/user/component/NotFound";
import ResetPassword from "../components/user/component/reset_password";
import SocialMediaLinks from "../components/user/component/social_media/SocialMediaLinks";
import SpeakerRegistration from "../components/user/component/speaker_registration";

const AppRouters = () => {
  const location = useLocation();
  const isAuthenticated = () => !!localStorage.getItem("userDetails");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    // Extract specific query parameters
    const testUserToken = queryParams.get('e');
    if (testUserToken) {
      localStorage.setItem(`access_token`, testUserToken);
      const decoded = jwtDecode(testUserToken);
      setTestUser(testUserToken);
      console.log("local user", decoded);
    }
  }, []);

  const authGuard = (Component) => {
    var testUser = JSON.parse(localStorage.getItem("userDetails"));
    setTestUser(testUser)
    return localStorage.getItem("userDetails") ?
      Component : <Navigate to="/login" />
  };

  const redirectIfAuthenticated = (Component) => {
    return isAuthenticated() ? <Navigate to="/quiz" /> : Component;
  };

  return (
    <>
      <Routes>
        <Route exact path="/" element={<QuizStudioLandingPage />} />
        <Route exact path="/quiz" element={authGuard(<Dashbaord />)} />
        <Route exact path="/quiz/tests" element={authGuard(<QuizTestsList />)} />
        {/* <Route exact path="/quiz/test/:id" element={<QuizTestDashboard />} /> */}
        <Route exact path="/quiz/test/:id" element={authGuard(<QuizTestPage />)} />
        <Route exact path="/quiz/test/review/report/:id" element={authGuard(<ReportReview />)} />
        {/* <Route exact path="/login" element={<Login />} /> */}
        <Route exact path="/login" element={redirectIfAuthenticated(<Login />)} />
        <Route exact path="/confirmation" element={<Confirmation />} />
        <Route exact path="/forgot_password" element={<ForgotPassword />} />
        <Route exact path="/reset_password" element={<ResetPassword />} />
        {/* <Route exact path="/create_quiz_test_question" element={<CreateQuestion />} /> */}
        <Route exact path="/create_quiz_test_settings" element={<CreateQuizSettings />} />
        {/* -------------------- */}
        <Route exact path="/social_media" element={<SocialMediaLinks />} />
        <Route exact path="/speaker_form" element={<SpeakerRegistration />} />
        {/* ------------------------ */}
        <Route exact path="/test/:id" element={<QuizTestPage />} />
        <Route exact path="/:id/playground" element={authGuard(<QuizPlayboard />)} />
        <Route exact path="/:id/report" element={<QuizTestReport />} />
        {/* <Route exact path="/assessment" element={<AssessmentTest />} /> */}
        <Route exact path="/assessments" element={authGuard(<AssessmentSkillTest />)} />
        <Route exact path="/assessments/:id" element={authGuard(<WelcomeTestInstruction />)} />
        <Route exact path="/assessment/test/:id" element={authGuard(<Assessment />)} />
        <Route exact path="/assessment/test/:id/report" element={<AssessmentReport />} />
        <Route exact path="/placement" element={<PlacementPrep />} />
        <Route exact path="/placement/:title" element={<ChoosePathDetailsPage />} /> {/*new */}
        <Route exact path="/exam" element={<ExamPrep />} />
        <Route exact path="/certificate" element={<CertificatePage />} />
        <Route path="/certificate/:title" element={<CertificateDetailPage />} />
        <Route exact path="/Tournaments" element={<TournamentsPage />} />
        <Route exact path="/Tournaments/:title" element={<TournamentsDetailPage />} />
        <Route exact path="/tournaments-register/:title" element={<TournamentRegisterPage />} />
        <Route exact path="/quizzes" element={authGuard(<QuizzesLibrary />)} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

const mapDispatchToProps = {
  setTestUser,
};

export default connect(null, mapDispatchToProps)(AppRouters);